import React, { Suspense } from 'react';
import classnames from 'classnames';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import { useNotificationBiString } from '../../utils/notificationToBiString';
import { NCNotification as NCNotificationType } from '../../types/nc';
import { renderNotification } from './renderNotification';
import s from './NCNotification.scss';

export interface Props {
  notification: NCNotificationType;
  isLoading?: boolean;
  className?: string;
}

const NCNotification: React.FC<Props> = ({ notification, isLoading, className }) => {
  const notificationBiString = useNotificationBiString(notification);
  return (
    <ErrorBoundary
      debugComponent={`NCNotification${notification.messageClass}${notification.type}`}
    >
      <BiLoggerContextProvider
        value={{
          notification_message_id: notification.messageId,
          notification_type: notificationBiString,
        }}
      >
        <div
          className={classnames(isLoading && s['loading'], className)}
          data-nc={`${notification.bucket}-${notification.messageClass}-${notification.type}`}
        >
          <Suspense fallback={null}>{renderNotification(notification)}</Suspense>
        </div>
      </BiLoggerContextProvider>
    </ErrorBoundary>
  );
};
NCNotification.displayName = 'NCNotification';

export default NCNotification;
